import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PracticeAgentBridgeService } from './practice-agent-bridge.service';

@Component({
  selector: 'app-practice-agent-widget',
  templateUrl: './practice-agent-widget.component.html',
  styleUrls: ['./practice-agent-widget.component.scss'],
  providers: [PracticeAgentBridgeService],
})
export class PracticeAgentWidgetComponent implements OnInit, OnDestroy {
  @ViewChild('practiceAgentIframe') private practiceAgentIframe: ElementRef<HTMLIFrameElement>;

  readonly enabled$ = this.bridgeService.enabled$;
  readonly visible$ = this.bridgeService.visible$;
  readonly expanded$ = this.bridgeService.expanded$;
  readonly sidebarOpen$ = this.bridgeService.sidebarOpen$;
  readonly wideSidebarOpen$ = this.bridgeService.wideSidebarOpen$;
  readonly widgetUrl: SafeResourceUrl | null;
  collapsed = false;

  constructor(
    public bridgeService: PracticeAgentBridgeService,
    sanitizer: DomSanitizer
  ) {
    const validatedWidgetUrl = this.bridgeService.validatedWidgetUrl;
    this.widgetUrl = validatedWidgetUrl ? sanitizer.bypassSecurityTrustResourceUrl(validatedWidgetUrl) : null;
  }

  ngOnInit(): void {
    this.bridgeService.start();
  }

  onIframeLoad(): void {
    if (this.practiceAgentIframe) {
      this.bridgeService.connectIframe(this.practiceAgentIframe.nativeElement);
    }
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
    this.bridgeService.trackCollapsed(this.collapsed);
  }

  snooze(): void {
    this.collapsed = false;
    this.bridgeService.snooze();
  }

  dismiss(): void {
    this.collapsed = false;
    this.bridgeService.dismiss();
  }

  ngOnDestroy(): void {
    this.bridgeService.destroy();
  }
}
